// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Kdxi","large":"styles_large__aHlUO"};